import * as React from "react";
const SvgRadioEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 16, r: 7.5, stroke: "currentColor" }));
export default SvgRadioEmpty;
